import { useParams } from '@fs/zion-router'
import { type FilterChoiceType } from '../types'

export default function useFilterType(): FilterChoiceType {
  const { filterType } = useParams() as {
    filterType?: string
  }
  return (filterType?.toUpperCase().replace(/-/g, '_') as FilterChoiceType) ?? 'ALL'
}
